import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"teahouse"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 7L20 11V21H4V11L7 7V4H17V7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 3V4M17 4V7M17 4H18M17 4H7M17 7H7M17 7L20 11M7 7V4M7 7L4 11M7 4V3M7 4H6M4 11V21M4 11H3M4 11H9M4 21H3M4 21H9M20 11V21M20 11H21M20 11H15M20 21H21M20 21H15M9 21V11M9 21H15M9 11H15M15 11V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Teahouse = Vue.extend<IconProps>({
  name: 'TeahouseIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'teahouse',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Teahouse;
